var searchResultsInit = function () {

    searchResults();

    $(document).ajaxComplete(function () {
        $('[data-id="spinner"]').removeClass("js-active");
        searchResults();
    });

    $(document).ready(function () {
        $("#ui-id-1").on('click', function (e) {
            $.cookie("searchtab", "webpages", { expires: 365, path: "/" });
        });

        $("#ui-id-2").on('click', function (e) {
            $.cookie("searchtab", "docs", { expires: 365, path: "/" });
        });

        if ($.cookie("searchtab") == "docs") {
            $("#ui-id-2").trigger('click');
        }

        if ($("#ui-id-2").parent().attr("aria-selected") == "true") {
            $("#docs").show();
        }

        if ($("div.l-row").first().children("div.m-alert").length > 0) {
            $("#docs").hide();
        }

    });

}
var searchResults = function () {

    // HTML containers of the results
    var resultsContainerWeb = $('[data-id="web-results-container"]'),
    resultsContainerDoc = $('[data-id="doc-results-container"]'),
    moreResultsContainerDoc = $('[data-id="doc-more-results-container"]'),
    docContainer = $('[data-id="doc-container"]'),
    categorySelect = $('[data-id=functional-area-facet]'),
    sortOrderSelect = $('[data-id=sort-order]'),
    typeSelect = $('[data-id=records-type-facet]'),
   
    // Anchor tags for 'more results' for no-script browsers
    querystringPaginationWeb = $('[data-id="querystring-pagination-web"]'),
    querystringPaginationDoc = $('[data-id="querystring-pagination-doc"]'),

    // Anchor tags for 'more results' for scripted browsers
    jQueryPaginationWeb = $('[data-id="jquery-pagination-web"]'),
    jQueryPaginationDoc = $('[data-id="jquery-pagination-doc"]'),

    // 'More result' buttons
    moreWebResultsBtn = $('[data-id="more-web-results"]'),
        moreDocResultsBtn = $('[data-id="more-doc-results"]'),

    lastLink = moreWebResultsBtn.closest('div.search-results').find('ol li:last-child a'),

    // Hidden inputs containing the active page for AJAX calls
    nextWebPageCounter = $('[data-id="web-next-page-counter"]'),
    nextDocPageCounter = $('[data-id="doc-next-page-counter"]'),

    // Hidden inputs containing base URLs for AJAX calls
    urlNextPageAjaxWeb = $('[data-id="web-next-page-json-url"]'),
    urlNextPageAjaxDoc = $('[data-id="doc-next-page-json-url"]'),

    // new search document tab button
    moreDocLoadBtn = $('[data-id="more-doc-load"]'),
    urlDocLoadPageAjax = $('[data-id="doc-json-url"]'),
    docResultCountHolder = $('[data-id="doc-result-count"]'),

    /*
    Furniture
    */
    submittedVia = $('[data-id="submitted-via"]'),
    documentsTab = $('#ui-id-2'),

    /*
     * check if last page
     */
    lastPage = $('[data-id="last-page"]'),
    lastDoc = $('[data-id="last-doc"]');


    /*
    Web results
    */

    if (querystringPaginationWeb.length && jQueryPaginationWeb.length) {
        // Hide the no-script pagination controls and then show the scripted pagination controls
        querystringPaginationWeb.hide();
        if (lastPage.length <= 0) {
            jQueryPaginationWeb.show();
        }

        // Click event for web AJAX pagination
        moreWebResultsBtn.one("click", function(evt) {
            evt.preventDefault();
            lastLink.addClass('lastLink');
            
            var url = urlNextPageAjaxWeb.val();

            if (url.indexOf('?') < 0)
                url += '?';
            else
                url += '&';

            url += 'pg=' + nextWebPageCounter.val();

            $.get(url, function (data) {
                resultsContainerWeb.append(data);
                firstLink = $('.lastLink').closest('li').next().find('a');
                firstLink.focus();
                $('.lastLink').removeClass('lastLink');
                    if (data.length >= 10) {
                        nextWebPageCounter.val(parseInt(nextWebPageCounter.val()) + 1);
                    } else {
                        jQueryPaginationWeb.hide();
                    }
                
                //for IE fix
                    if (data.indexOf('<!-- last -->') != -1)
                        jQueryPaginationWeb.hide();
            });

        });
    }

    /*
    Document results
    */

    if (querystringPaginationDoc.length && jQueryPaginationDoc.length) {
        // Hide the no-script pagination controls and then show the scripted pagination controls
        querystringPaginationDoc.hide();
        if (lastDoc.length <= 0) {
            jQueryPaginationDoc.show();
        }

        // Click event for document AJAX pagination
        moreDocResultsBtn.one("click", function(evt) {
            evt.preventDefault();

            var url = urlNextPageAjaxDoc.val();

            if (url.indexOf('?') < 0)
                url += '?';
            else
                url += '&';

            url += 'pg=' + nextDocPageCounter.val();
        
            $.get(url, function(data) {
                resultsContainerDoc = $('[data-id="doc-results-container"]');
                resultsContainerDoc.append(data);
                if (data.length >= 10) {
                    nextDocPageCounter.val(parseInt(nextDocPageCounter.val()) + 1);
                } else {
                    jQueryPaginationDoc.hide();
                }

                //IE fix
                //if (data.indexOf('<!-- last -->') != -1)
                    jQueryPaginationDoc.hide();

            });
        });
    }
    /*
    New search documents
    */
    var customSelects = $('[data-id=doc-container] .custom-select');
    moreDocLoadBtn.one("click", function(evt) {
        evt.preventDefault();
        var url = urlDocLoadPageAjax.val();
     
        $.get(url, function (data) {
            var receivedContainer = $(data),
                searchedDocsMarkupOnAjax = receivedContainer.find('[data-id=doc-results-container]').html(),
                moreDocsMarkupOnAjax = receivedContainer.find('[data-id=doc-more-results-container]').html(),
                categorySelectOnAjax = receivedContainer.find('[data-id=functional-area-facet]').html(),
                sortOrderOnAjax = receivedContainer.find('[data-id=sort-order]').html(),
                typeSelectOnAjax = receivedContainer.find('[data-id=records-type-facet]').html(),
                resultsCountOnAjax = receivedContainer.find('#results-count').val();

            resultsContainerDoc.html(searchedDocsMarkupOnAjax);
            moreResultsContainerDoc.html(moreDocsMarkupOnAjax);
            categorySelect.html(categorySelectOnAjax);
            sortOrderSelect.html(sortOrderOnAjax);
            typeSelect.html(typeSelectOnAjax);

            docResultCountHolder.html('(' + resultsCountOnAjax + ')');
        });
    });
}
